import {
  takeEvery,
  call,
  put,
  all,
  fork,
  CallEffect,
  PutEffect,
} from 'redux-saga/effects';
import { ActionTypes } from '../../constants/ActionTypes';
import {
  onFetchDraftEmployeePositionFoldersSuccess,
  onFetchInboxEmployeePositionfoldersSuccess,
  onFetchSendBoxEmployeePositionFoldersSuccess,
  onFetchTrashEmployeePositionFoldersSuccess,
} from '../actions';
import { ShowError } from '../../helper/Alert';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { AxiosResponse } from 'axios';

const getInboxEmployeePositionFolders = async (parentId: number | null) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `instance/GetEmployeePositionFolders?employeePositionFolderType=Inbox&parentId=${parentId}`,
  );
};

const getSendBoxEmployeePositionFolders = async (parentId: number | null) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `instance/GetEmployeePositionFolders?employeePositionFolderType=SentItem&parentId=${parentId}`,
  );
};

const getDraftEmployeePositionFolders = async (parentId: number | null) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `instance/GetEmployeePositionFolders?employeePositionFolderType=Draft&parentId=${parentId}`,
  );
};

// const getTrashEmployeePositionFolders = async (parentId: number | null) => {
//   const http = await FaraGostarDynamicHttp();
//   return await http.get(
//     `instance/LetterDeletedRead?employeePositionFolderType=Deleted&parentId=${parentId}`,
//   );
// };

function* fetchInboxEmployeePositionFoldersRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchInboxEmployeePositionFolders = yield call(
      getInboxEmployeePositionFolders,
      action.payload,
    );
    yield put(
      onFetchInboxEmployeePositionfoldersSuccess(
        fetchInboxEmployeePositionFolders.data,
      ),
    );
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchInboxEmployeePositionFolders() {
  yield takeEvery(
    ActionTypes.GET_INBOX_EMPLOYEE_POSITION_FOLDERS,
    fetchInboxEmployeePositionFoldersRequest,
  );
}

function* fetchSendBoxEmployeePositionFoldersRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchSendBoxEmployeePositionFolders = yield call(
      getSendBoxEmployeePositionFolders,
      action.payload,
    );
    yield put(
      onFetchSendBoxEmployeePositionFoldersSuccess(
        fetchSendBoxEmployeePositionFolders.data,
      ),
    );
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchSendBoxEmployeePositionFolders() {
  yield takeEvery(
    ActionTypes.GET_SENDBOX_EMPLOYEE_POSITION_FOLDERS,
    fetchSendBoxEmployeePositionFoldersRequest,
  );
}

function* fetchDraftEmployeePositionFoldersRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchDraftEmployeePositionFolders = yield call(
      getDraftEmployeePositionFolders,
      action.payload,
    );
    yield put(
      onFetchDraftEmployeePositionFoldersSuccess(
        fetchDraftEmployeePositionFolders.data,
      ),
    );
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchDraftEmployeePositionFolders() {
  yield takeEvery(
    ActionTypes.GET_Draft_EMPLOYEE_POSITION_FOLDERS,
    fetchDraftEmployeePositionFoldersRequest,
  );
}

// function* fetchTrashEmployeePositionFoldersRequest(
//   action: any,
// ): Generator<
//   | CallEffect<AxiosResponse<any>>
//   | PutEffect<{ type: ActionTypes; payload: any }>,
//   void,
//   AxiosResponse<any>
// > {
//   try {
//     const fetchTrashEmployeePositionFolders = yield call(
//       getTrashEmployeePositionFolders,
//       action.payload,
//     );
//     yield put(
//       onFetchTrashEmployeePositionFoldersSuccess(
//         fetchTrashEmployeePositionFolders.data,
//       ),
//     );
//   } catch (error) {
//     return ShowError('', error);
//   }
// }

// export function* fetchTrashEmployeePositionFolders() {
//   yield takeEvery(
//     ActionTypes.GET_TRASH_EMPLOYEE_POSITION_FOLDERS,
//     fetchTrashEmployeePositionFoldersRequest,
//   );
// }

export default function* rootSaga() {
  yield all([
    fork(fetchInboxEmployeePositionFolders),
    fork(fetchSendBoxEmployeePositionFolders),
    fork(fetchDraftEmployeePositionFolders),
    ///fork(fetchTrashEmployeePositionFolders),
  ]);
}
